const API_BASE_URL = process.env.VITE_API_URL || 'http://localhost:4000';
class ApiService {
    constructor(baseUrl = API_BASE_URL) {
        this.baseUrl = baseUrl;
    }
    async request(endpoint, options) {
        try {
            const response = await fetch(`${this.baseUrl}${endpoint}`, {
                headers: {
                    'Content-Type': 'application/json',
                    ...options?.headers,
                },
                ...options,
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'An error occurred');
            }
            return data;
        }
        catch (error) {
            console.error('API request failed:', error);
            throw error;
        }
    }
    // Health check
    async healthCheck() {
        return this.request('/api/health');
    }
    // Get all parcels
    async getAllParcels() {
        return this.request('/api/parcels');
    }
    // Track a parcel by tracking number
    async trackParcel(trackingNumber) {
        return this.request(`/api/parcels/track/${trackingNumber.toUpperCase()}`);
    }
    // Create a new parcel
    async createParcel(parcelData) {
        return this.request('/api/parcels', {
            method: 'POST',
            body: JSON.stringify(parcelData),
        });
    }
    // Update parcel status
    async updateParcelStatus(trackingNumber, statusUpdate) {
        return this.request(`/api/parcels/${trackingNumber.toUpperCase()}/status`, {
            method: 'PUT',
            body: JSON.stringify(statusUpdate),
        });
    }
    // Update (or clear) the estimated delivery date
    async updateDeliveryDate(trackingNumber, estimatedDelivery) {
        return this.request(`/api/parcels/${trackingNumber.toUpperCase()}/delivery-date`, {
            method: 'PATCH',
            body: JSON.stringify({ estimatedDelivery }),
        });
    }
    // Delete a parcel
    async deleteParcel(trackingNumber) {
        return this.request(`/api/parcels/${trackingNumber.toUpperCase()}`, {
            method: 'DELETE',
        });
    }
    // Update a tracking history entry
    async updateTrackingHistory(trackingNumber, historyId, updates) {
        return this.request(`/api/parcels/${trackingNumber.toUpperCase()}/history/${historyId}`, {
            method: 'PATCH',
            body: JSON.stringify(updates),
        });
    }
    // Delete a tracking history entry
    async deleteTrackingHistory(trackingNumber, historyId) {
        return this.request(`/api/parcels/${trackingNumber.toUpperCase()}/history/${historyId}`, {
            method: 'DELETE',
        });
    }
    // Trigger automatic status updates
    async triggerAutoUpdate() {
        return this.request('/api/parcels/auto-update/trigger', {
            method: 'POST',
        });
    }
}
// Export a singleton instance
export const apiService = new ApiService();
export default apiService;
